import { CloseIcon } from '@assets/icons/CloseIcon';
import Bowser from 'bowser';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseButton } from '../Buttons';
import styles from './_browserWarning.module.scss';

export const BrowserWarning: React.FC = () => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);
  const [disabled, setDisabled] = useState(
    localStorage.getItem('imagery_browser_warning_disabled') === '1'
  );

  const isChrome = useMemo(() => {
    const browser = Bowser.getParser(window.navigator.userAgent);

    return browser.getBrowserName() === 'Chrome';
  }, []);

  const isOpen = useMemo(() => {
    return !isChrome && !dismissed && !disabled;
  }, [dismissed, disabled, isChrome]);

  const onClickDisable = () => {
    localStorage.setItem('imagery_browser_warning_disabled', '1');
    setDisabled(true);
  };

  if (!isOpen) return null;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <p className="typo typo--white">{t('apps.chrome_warning')}</p>
        <BaseButton variant="primary" onClick={onClickDisable}>
          {t('apps.chrome_warning_dismiss')}
        </BaseButton>
        <button type="button" className={styles.close} onClick={() => setDismissed(true)}>
          <CloseIcon fill="#FFF" width={24} height={24} />
        </button>
      </div>
    </div>
  );
};
